import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TextCSS from '@Components/Common/Text/Styles';

import Page from './Page';
import StoreItem from './StoreItem';

const TAB_TYPE = {
  PAGE: 'page',
  ITEM: 'item',
};

const TAB_KOR_TYPE = {
  [TAB_TYPE.PAGE]: '페이지',
  [TAB_TYPE.ITEM]: '아이템',
};

const Tab = ({
  isDataFetching,
  pageElements,
  itemElements,
  scrollToTargetProcess,
  ReactPaginateCompo,
  searchPidFunc,
}) => {
  const [activeTab, setActiveTab] = useState(TAB_TYPE.PAGE);

  return (
    <>
      <TabContentContainer>
        <TabTitle
          tabValue={TAB_TYPE.PAGE}
          activeTab={activeTab}
          onClick={() => setActiveTab(TAB_TYPE.PAGE)}
          style={{ userSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none' }}
        >
          {TAB_KOR_TYPE[TAB_TYPE.PAGE]}
        </TabTitle>

        <TabTitle
          tabValue={TAB_TYPE.ITEM}
          activeTab={activeTab}
          onClick={() => setActiveTab(TAB_TYPE.ITEM)}
          style={{ userSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none' }}
        >
          {TAB_KOR_TYPE[TAB_TYPE.ITEM]}
        </TabTitle>
      </TabContentContainer>

      {/* <PagiNationContainer> */}
      {ReactPaginateCompo()}
      {/* </PagiNationContainer> */}
      {isDataFetching ? null : (
        <TabItemWrapper>
          {activeTab === TAB_TYPE.PAGE ? (
            <Page pageElements={pageElements} scrollToTargetProcess={scrollToTargetProcess} />
          ) : (
            <StoreItem
              itemElements={itemElements}
              scrollToTargetProcess={scrollToTargetProcess}
              searchPidFunc={searchPidFunc}
            />
          )}
        </TabItemWrapper>
      )}
    </>
  );
};

Tab.propTypes = {
  isDataFetching: PropTypes.bool.isRequired,
  pageElements: PropTypes.arrayOf(PropTypes.shape({ pageId: PropTypes.number, pageText: PropTypes.string })).isRequired,
  itemElements: PropTypes.arrayOf(PropTypes.string).isRequired,
  scrollToTargetProcess: PropTypes.func.isRequired,
};

const TabContentContainer = styled.ul`
  display: flex;
  flex-direction: row;

  padding: 0px;
  margin-top: 40px;
`;

const TabTitle = styled.li`
  ${TextCSS.BodyB}

  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;

  opacity: ${({ activeTab, tabValue }) => {
    if (activeTab !== tabValue) {
      return 0.5;
    }

    return 1;
  }};
`;

// const PagiNationContainer = styled.div`
//   width: 100%;
//   display: flex;
//   flex-wrap: wrap;
//   & > div {
//     margin: 3px;
//   }
// `;

const TabItemWrapper = styled.div`
  display: flex;
  width: 100%;

  margin-top: 28px;
`;

export default Tab;
